import React from 'react';
import ReactDOM from 'react-dom';
import Routes from './routes';
import registerServiceWorker from './registerServiceWorker';
require('dotenv').config();

ReactDOM.render(
	<Routes />,
	document.getElementById('root')
);
registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js